import {
  getData,
} from './index';
import {
  STATS_GET,
  STATS_LOADING,
  STATS_ERROR,
} from './types';

const getStats = async (dispatch, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/stats${queryString ? `?${queryString}` : ''}`;
  dispatch({
    type: STATS_LOADING,
    payload: STATS_GET,
  });
  const response = await getData(STATS_ERROR, url, dispatch, true);
  if (response.data) {
    setTimeout(() => {
      dispatch({
        type: STATS_GET,
        payload: response.data,
      });
    }, 500);
  }
};

export default getStats;
